import React from "react";
import toast from "react-hot-toast";

import { DirectoryAvatar } from "./DirectoryAvatar";

/** Must match backend AVATAR_ALLOWED_CONTENT_TYPES / DIRECTORY_PHOTO_ALLOWED in s3_service.py. */
const ALLOWED_TYPES = ["image/jpeg", "image/png", "image/webp"];
/** Must match backend DIRECTORY_PHOTO_MAX_BYTES default (src/config/settings/base.py). */
const MAX_BYTES = 2 * 1024 * 1024;

type Props = {
  name: string;
  photoUrl?: string | null;
  onUpload: (file: File) => Promise<unknown>;
  uploading: boolean;
};

export const PhotoUploadField: React.FC<Props> = ({ name, photoUrl, onUpload, uploading }) => {
  const handleChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    if (!ALLOWED_TYPES.includes(file.type)) {
      toast.error("Photo must be a JPEG, PNG, or WEBP image");
      return;
    }
    if (file.size > MAX_BYTES) {
      toast.error("Photo must be 2MB or smaller");
      return;
    }
    try {
      await onUpload(file);
      toast.success("Photo updated");
    } catch (err) {
      toast.error(err instanceof Error ? err.message : "Failed to upload photo");
    }
  };

  return (
    <label className="eventos-field directory-photo-upload">
      <span className="eventos-field-label">Photo</span>
      <div className="directory-photo-upload__row">
        <DirectoryAvatar name={name} photoUrl={photoUrl} className="directory-photo-upload__avatar" />
        <span className="eventos-nav-btn directory-photo-upload__btn">
          {uploading ? "Uploading…" : "Upload photo"}
          <input
            type="file"
            accept="image/jpeg,image/png,image/webp"
            onChange={handleChange}
            disabled={uploading}
            className="directory-photo-upload__input"
          />
        </span>
      </div>
      <span className="eventos-subtle">JPEG, PNG, or WEBP up to 2MB.</span>
    </label>
  );
};
